import React, { useState } from 'react';
import ButtonLoader from './ButtonLoader';
import './Button.scss';
import { getRedirection } from '../../../utils';
import { startLoading, endLoading } from '../../../store/features/app/app';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';

interface IButtonProps {
  type: 'shop' | 'preorder' | 'secondary' | 'discover';
  content: string;
  redirection?: {
    type: 'product' | 'category' | 'custom';
    value: string;
  };
  Tag?: any | string;
  tracking?: string;
  loaderFill?: string;
  countryCode?: string;
  buttonType?: string;
  classes?: string;
  noButtonClasses?: boolean;
  handleClick?: (id?: string) => Promise<any> | void;
}

const Button = ({
  type,
  redirection,
  content,
  Tag = 'a',
  loaderFill = 'white',
  countryCode,
  buttonType = 'button',
  handleClick,
  classes,
  noButtonClasses = false
}: IButtonProps) => {
  const [clicked, setClicked] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.app.loading);
  const redirectionValue =
    redirection && Tag === 'a'
      ? getRedirection(
          redirection.type,
          redirection.value,
          countryCode ? countryCode : null
        )
      : undefined;
  const buttonClasses = !noButtonClasses ? `btn btn__${type}` : '';

  const triggerClick = async () => {
    setClicked(true);
    dispatch(startLoading());
    await handleClick();
    dispatch(endLoading());
    setClicked(false);
  };

  return (
    <Tag
      {...(Tag === 'button' && { type: buttonType })}
      {...(Tag !== 'button' && { href: redirectionValue })}
      suppressHydrationWarning={true}
      className={`${buttonClasses} ${
        !redirection && loading ? 'loading ' : ''
      }${clicked ? 'clicked ' : ''}${classes}`}
      data-alt-text={content}
      onClick={handleClick ? triggerClick : undefined}
    >
      {!redirection && loading && clicked && <ButtonLoader fill={loaderFill} />}
      <span>{content}</span>
    </Tag>
  );
};

export default Button;
